import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { SearchParam } from "../helpers/SearchParam";
import { Settings } from "../multigame/Settings";
import { DEVELOPMENT } from "../multigame/version";
import { SinglegameServerHub } from "./singlegame_api";


function FindSinglegameServer(): string
{
    let keys = [
        "hash",
        "host",
        "hostname",
        "href",
        "origin",
        "pathname",
        "port",
        "protocol",
        "search",
    ];

    let url = Settings.Server.toString();

    for (let k of keys)
    {
        url = url.replace("{" + k + "}", window.location[k]);
    }

    url += "/api/v1/singlegame/ws";
    // url = "https://gp.beta.dixpagames.si/api/v1/singlegame/ws";

    return url;
}

export function CreateSinglegameConnection()
{
    const singlegameServer = FindSinglegameServer();

    return new HubConnectionBuilder()
        .withUrl(singlegameServer)
        .build();
}

export class SinglegameApi extends SinglegameServerHub
{
    public constructor(_singlegameConnection: HubConnection) {
        super(_singlegameConnection);
    }
}

